import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons (they break under bundlers). Use CDN icons.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

/**
 * points: [{lat, lng, title, subtitle}]
 * center: [lat, lng] or null (uses first point)
 */
export default function SchoolMap({ points = [], center = null, zoom = 14, height = 320 }) {
  const validPoints = points.filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
  const middle = useMemo(() => {
    if (center) return center;
    if (validPoints.length) return [validPoints[0].lat, validPoints[0].lng];
    return [39.925533, 32.866287]; // Ankara fallback
  }, [center, validPoints]);

  if (!validPoints.length) {
    return (
      <div
        className="rounded-xl border border-dashed border-border bg-muted/30 text-sm text-muted-foreground flex items-center justify-center"
        style={{ height }}
        data-testid="school-map-empty"
      >
        Konum bilgisi henüz eklenmemiş. Okul yönetimi kampüs koordinatlarını eklediğinde harita burada görünecek.
      </div>
    );
  }

  const first = validPoints[0];
  const directionsUrl = `https://www.openstreetmap.org/directions?to=${first.lat}%2C${first.lng}`;

  return (
    <div className="rounded-xl overflow-hidden border border-border relative" data-testid="school-map">
      <MapContainer center={middle} zoom={zoom} style={{ height, width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {validPoints.map((p, i) => (
          <Marker key={i} position={[p.lat, p.lng]}>
            <Popup>
              <div className="font-semibold">{p.title}</div>
              {p.subtitle && <div className="text-xs text-muted-foreground">{p.subtitle}</div>}
              <a
                href={`https://www.openstreetmap.org/directions?to=${p.lat}%2C${p.lng}`}
                target="_blank"
                rel="noreferrer"
                className="text-primary underline text-xs mt-1 inline-block"
              >
                Yol Tarifi Al
              </a>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      <a
        href={directionsUrl}
        target="_blank"
        rel="noreferrer"
        className="absolute bottom-3 right-3 z-[500] bg-background/90 backdrop-blur border border-border px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-background shadow"
        data-testid="school-directions-btn"
      >
        📍 Yol Tarifi Al
      </a>
    </div>
  );
}
